import React, { useCallback, useEffect, useState } from "react";
import { MediaFile } from "src/api/public-types";
import ImagesDetail from "src/components/ImagesDetail";
import useApiLoading from "src/hooks/useApiLoading";

type Props = {
  type: string;
  images: MediaFile[];
};

const ImageCategoryDetail = ({ type, images }: Props) => {
  const [filteredImage, setFilteredImage] = useState<Array<MediaFile>>([]);

  const { isApiLoading } = useApiLoading();

  useEffect(() => {
    if (images) {
      setFilteredImage(images.filter((image) => image.mediaServiceType === type));
    }
  }, [images]);

  const getCategoryName = useCallback((category: string) => {
    let typeName = "";

    switch (category) {
      case "MEDIA_BUILDING":
        typeName = "외부";
        break;

      case "MEDIA_BUILDING_INSIDE":
        typeName = "내부";
        break;
      case "MEDIA_BUILDING_FLOOR_ROOM":
        typeName = "층,호실";
        break;
      case "MEDIA_BUILDING_COMMONFACILITY":
        typeName = "공용시설";
        break;

      case "MEDIA_BUILDING_ETC":
        typeName = "기타";
        break;
    }
    return typeName;
  }, []);

  return (
    <div>
      <section className="mb30">
        <div className="contents-container__grid ">
          <div className="contents-container__grid-index ">
            <p className="no-wrap">{`건물 / ${type && getCategoryName(type)} (${filteredImage.length}/10)`}</p>
          </div>
        </div>
        {filteredImage.length ? (
          <ImagesDetail type={type} images={filteredImage} isUsedRepresentative={true} isUsedDescription={true} isUsedSelfDescription={true} />
        ) : (
          <p className="font13">{!isApiLoading() && "등록된 이미지가 없습니다"}</p>
        )}
      </section>
    </div>
  );
};

export default ImageCategoryDetail;
